import Corks from '@/app/[locale]/wallet/components/commons/Corks';
import { useTranslations } from 'next-intl';
import { Button } from 'src/components/design-system';
import Cork from 'src/components/icons/Cork';
import { Link } from '../../../../../../navigation';

interface Props {
  missingLoyaltyPoints: number;
}

const MissingLoyaltyPoints: React.FC<Props> = (props) => {
  const t = useTranslations('loyalty');

  return (
    <div className="tw-space-y-4">
      <div className="tw-text-base tw-text-center tw-border tw-p-4 tw-rounded-lg tw-text-gray-500">
        {t.rich('prizeDetail.missingLoyaltyPoints', {
          0: () => (
            <Corks
              loyaltyPoints={props.missingLoyaltyPoints}
              numberSize="base"
              corkSize="4"
              corkColor="gray-500"
              numberColor="gray-500"
            />
          ),
        })}
      </div>
      <Link href={{ pathname: '/wallet', hash: 'referral' }}>
        <Button type="link" size="lg" className="tw-text-xl tw-w-full">
          {t.rich('prizeDetail.inviteAFriend', {
            0: () => <Cork />,
          })}
        </Button>
      </Link>
    </div>
  );
};

export default MissingLoyaltyPoints;
